module.exports = __webpack_public_path__ + "img/fitila.6afc96e0.svg";